import { Component, OnInit, Inject } from '@angular/core';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
@Component({
  selector: 'app-team-lead-view',
  templateUrl: './team-lead-view.component.html',
  styleUrls: ['./team-lead-view.component.css'],
  standalone: true,
  imports: [FormsModule, RouterModule, LoaderComponent]
})
export class TeamLeadViewComponent implements OnInit {
  teamLead: any;
  public user: any = [];
  public showSpinner = true;
  user_dep: any;
  user_role: any;
  constructor(
    @Inject(AddService) private addService: AddService,
    public router: Router
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin") {
      this.router.navigate(['/dashboard-1']);
    }
    this.user_dep = this.user.department;
    this.user_role = JSON.parse(this.user.user_role.user_roles)

  }
  ngOnInit(): void {
    this.showTeam(this.user_dep);
  }

  showTeam(department: any) {
    this.showSpinner = true;
    this.addService.teamLead(department).then((value) => {
      this.showSpinner = false;
      this.teamLead = value.data;
    });
  }


  departmentBackgrounds: Record<string, string> = {
    'Higher Management': '../../../assets/images/test-bg.png',
    'Human Resource Managment': '../../../assets/images/s-bg.png',
    'Team Leads': '../../../assets/images/t-bg.png',
    'Business Development': '../../../assets/images/mobile-bg.png',
    'Web Application Development': '../../../assets/images/mobile-bg.png',
    'Mobile Application Development': '../../../assets/images/mobile-bg.png',
    'Graphic Designers': '../../../assets/images/mobile-bg.png',
    'Quality Insurance': '../../../assets/images/mobile-bg.png',
    'Demo Users': '../../../assets/images/mobile-bg.png',
    'Office Boys': '../../../assets/images/mobile-bg.png'
  };

  getFooterImages(department: string): string[] {
    // Define mappings for footer images based on department name
    const footerImageMappings: Record<string, string[]> = {
      'Higher Management': ['lnkd.png', 'fb.png', 'inst.png'],
      'Human Resource Managment': ['s-lnkd.png', 's-fb.png', 's-inst.png'],
      'Team Leads': ['lnkd-t.png', 'fb-t.png', 'inst-t.png'],
      'Business Development': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
      'Web Application Development': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
      'Mobile Application Development': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
      'Graphic Designers': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
      'Quality Insurance': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
      'Demo Users': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
      'Office Boys': ['lnkd-team.png', 'fb-team.png', 'inst-team.png'],
    };

    // Return the appropriate images for the department
    return footerImageMappings[department] || [];
  }
  // isApprovedPermission() : boolean{
  //   var user_role = JSON.parse(this.user.user_role.user_roles)
  //   if(user_role.role_type === "Employee"){
  //    return false
  //   }else if(user_role.role_type === "Team_Lead"){
  //     return false
  //   }else{
  //     return user_role.leave_data.data.values.accept
  //   }
  // }


}
